import { render, staticRenderFns } from "./service-support-description-unit.vue?vue&type=template&id=59509c3a&"
import script from "./service-support-description-unit.vue?vue&type=script&lang=js&"
export * from "./service-support-description-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports